import routeCodes from 'common/constants/route-codes';
import store from 'redux/store';

class RouterHelper {
  static getRouteName = (location) => {
    const { pathname } = location;
    let name;
    Object.keys(routeCodes).forEach((key) => {
      const path = routeCodes[key];
      if (pathname.includes(path)) {
        name = key;
      }
    });
    return name;
  };

  static getRouteWithRestaurantId = (path) => {
    if (path.includes('menu')) {
      const {
        common: { currentRestaurant },
      } = store.getState();
      return path.replace(':restaurantId', currentRestaurant?.id);
    }
    return path;
  };

  static getBreadcrumbItems = (pathname, homePage = 'Home', isSuperAdmin) => {
    let isInitDynamicRestaurantTitle = false;
    const {
      common: { currentRestaurant },
    } = store.getState();

    const items = [
      {
        link: '/',
        label: isSuperAdmin ? homePage : currentRestaurant?.title || homePage,
      },
    ];
    const splitPaths = pathname.split('/').filter(Boolean);
    if (pathname === '/') {
      items.push({
        link: '/',
        label: 'Home',
      });
    }

    splitPaths.forEach((path) => {
      const isDynamic = Number.isInteger(parseInt(path));
      if (!isInitDynamicRestaurantTitle && isDynamic && currentRestaurant?.id) {
        items.push({
          link: `/restaurants/${currentRestaurant?.id}`,
          label: currentRestaurant?.title,
        });
        isInitDynamicRestaurantTitle = true;
      }
      if (path.includes('profile')) {
        items.push({
          link: '/profile',
          label: 'Profile',
        });
      }
      if (path.includes('administration')) {
        items.push({
          link: '/administration',
          label: 'Amministrazione',
        });
      }
      if (path.includes('company')) {
        items.push({
          link: routeCodes.superAdmin.administrationCompany,
          label: 'Crea società',
        });
      }
      if (path.includes('owners')) {
        items.push({
          link: routeCodes.superAdmin.administrationOwners,
          label: 'Crea gestore',
        });
      }
      // if (path.includes('restaurants')) {
      //   items.push({
      //     link: routeCodes.superAdmin.administrationRestaurant,
      //     label: 'Crea insegna',
      //   });
      // }
      if (path === 'restaurant') {
        items.push({
          link: '/profile/restaurant/create',
          label: 'Anagrafica insegna',
        });
      }
      if (path === 'bonuses') {
        items.push({
          link: '/bonuses',
          label: 'Crea offerte',
        });
      }
      if (path === 'reminder') {
        items.push({
          link: '/reminder',
          label: 'Reminder',
        });
      }

      if (path === 'reservations') {
        items.push({
          link: '/reservations',
          label: 'Prenotazioni',
        });
      }

      if (path === 'firm') {
        items.push({
          link: '/profile/firm/create',
          label: 'Anagrafica gestora',
        });
      }
      if (path === 'all-bonuses') {
        items.push({
          link: '/all-bonuses',
          label: 'Buoni RistoraBergamo',
        });
      }
      if (path === 'menu') {
        items.push({
          link: routeCodes.menu,
          label: 'Menù',
        });
      }
      if (path === 'dishes') {
        items.push({
          link: routeCodes.menuDishesCreate,
          label: 'Crea piatto/prodotto',
        });
      }
      if (path === 'home') {
        items.push({
          link: routeCodes.superAdmin.restaurantHome.replace(
            ':restaurantId',
            currentRestaurant?.id,
          ),
          label: 'home',
        });
      }
      if (path === 'categories') {
        items.push({
          link: routeCodes.menuCategoriesCreate,
          label: 'Crea categorie',
        });
      }
      if (path === 'special-menu') {
        items.push({
          link: routeCodes.specialMenuCreate,
          label: 'Crea menù speciale',
        });
      }
      if (path === 'options') {
        items.push({
          link: routeCodes.menuOptionsCreate,
          label: 'Crea opzione',
        });
      }
      if (path === 'settings') {
        items.push({
          link: routeCodes.settings,
          label: 'Impostazioni',
        });
      }
      if (path === 'ipratico') {
        items.push({
          link: routeCodes.ipratico,
          label: 'Ipratico',
        });
      }
      if (path === 'statistics') {
        items.push({
          link: routeCodes.statistics,
          label: 'Statistiche',
        });
      }
      if (path === 'qr') {
        items.push({
          link: routeCodes.generateQR,
          label: 'Genera Codice QR code',
        });
      }
      if (path === 'restaurants') {
        items.push({
          link: routeCodes.restaurants,
          label: 'Ristoratori-Produttori',
        });
      }
      if (path === 'team') {
        items.push({
          link: routeCodes.team,
          label: 'Team',
        });
      }
      if (path === 'finances') {
        items.push({
          link: routeCodes.finances,
          label: 'Fatture',
        });
      }
      if (path === 'help') {
        items.push({
          link: routeCodes.help,
          label: 'Aiuto',
        });
      }
      if (path === 'offers') {
        items.push({
          link: routeCodes.offers,
          label: 'Offerte',
        });
      }
      if (path === 'notifications') {
        items.push({
          link: routeCodes.superAdmin.notifications,
          label: 'Area notifiche',
        });
      }
      if (path === 'bonus-amount') {
        items.push({
          link: routeCodes.offersCreatBonusAmount,
          label: 'Crea offerta',
        });
      }
      if (path === 'bonus-payment') {
        items.push({
          link: routeCodes.offersCreatPayment,
          label: 'Crea offerta',
        });
      }
      if (path === 'register') {
        items.push({
          link: routeCodes.register,
          label: 'Registro COVID-19',
        });
      }
      if (path === 'bonus-calendar') {
        items.push({
          link: routeCodes.offersCreatCalendar,
          label: 'Crea offerta',
        });
      }
    });

    return items;
  };

  static getRedirectRouteWithRestaurantId = (
    path = routeCodes.home,
    restaurantId,
  ) => {
    const {
      common: { currentRestaurant },
    } = store.getState();

    return path.replace(':restaurantId', restaurantId || currentRestaurant?.id);
  };

  static getRouteWithRestaurant = (path) => {
    const {
      common: { currentRestaurant },
    } = store.getState();
    return path.replace(':restaurantId', currentRestaurant?.id);
  };

  static correctionPathForSuperAdmin = (path) => {
    const {
      common: { currentRestaurant },
      user: { isSuperAdmin },
    } = store.getState();
    if (!isSuperAdmin) {
      return path;
    }

    return path.replace(':restaurantId', currentRestaurant?.id);
  };
}

export default RouterHelper;
